import { X } from "lucide-react";

export const Btn = ({ children, variant = "primary", className = "", ...props }) => {
  const styles = {
    primary: "bg-[#C5A059] text-[#0A0A0A] hover:bg-[#E5C887]",
    ghost: "bg-transparent border border-[#3f3f46] text-[#E4E4E7] hover:border-[#C5A059]",
    danger: "bg-red-500/90 text-white hover:bg-red-500",
    subtle: "bg-[#27272A] text-[#E4E4E7] hover:bg-[#3f3f46]",
  };
  return (
    <button {...props} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors disabled:opacity-50 ${styles[variant]} ${className}`}>
      {children}
    </button>
  );
};

export const Field = ({ label, children }) => (
  <label className="block">
    {label && <span className="block text-xs text-[#8C8375] mb-1.5 font-mono uppercase tracking-wide">{label}</span>}
    {children}
  </label>
);

export const Input = (props) => (
  <input {...props} className={`w-full bg-[#0F0F10] border border-[#27272A] rounded-md px-3 py-2.5 text-sm text-white outline-none focus:border-[#C5A059] transition-colors ${props.className || ""}`} />
);

export const Textarea = (props) => (
  <textarea {...props} className={`w-full bg-[#0F0F10] border border-[#27272A] rounded-md px-3 py-2.5 text-sm text-white outline-none focus:border-[#C5A059] transition-colors resize-none ${props.className || ""}`} />
);

export const Toggle = ({ checked, onChange, label, testid }) => (
  <button type="button" data-testid={testid} onClick={() => onChange(!checked)} className="flex items-center gap-2 text-sm text-[#A1A1AA]">
    <span className={`w-10 h-5 rounded-full transition-colors relative ${checked ? "bg-[#C5A059]" : "bg-[#3f3f46]"}`}>
      <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white transition-all ${checked ? "left-5" : "left-0.5"}`} />
    </span>
    {label}
  </button>
);

export const Modal = ({ open, onClose, title, children, testid }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={onClose}>
      <div data-testid={testid} className="bg-[#18181B] border border-[#27272A] rounded-lg w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-5 border-b border-[#27272A] sticky top-0 bg-[#18181B]">
          <h3 className="font-serif text-xl text-white">{title}</h3>
          <button onClick={onClose} className="text-[#8C8375] hover:text-white"><X size={20} /></button>
        </div>
        <div className="p-5 space-y-4">{children}</div>
      </div>
    </div>
  );
};

export const Confirm = ({ open, onClose, onConfirm, message }) => (
  <Modal open={open} onClose={onClose} title="Confirmar" testid="confirm-dialog">
    <p className="text-sm text-[#E4E4E7]">{message}</p>
    <div className="flex gap-3 justify-end pt-2">
      <Btn variant="ghost" onClick={onClose}>Cancelar</Btn>
      <Btn variant="danger" data-testid="confirm-delete-btn" onClick={onConfirm}>Eliminar</Btn>
    </div>
  </Modal>
);

export const Empty = ({ children }) => (
  <div className="text-center py-16 text-[#8C8375] text-sm">{children}</div>
);
